export const AMENDATORY_ENDORSEMENT = 'Amendatory Endorsements';
export const UW_ERROR_CLASS = 'uw-error';
export const MULTI_YEAR_POLICY = 'MULTI_YEAR_POLICY';
